<deposit-end-screen-wrapper class="bp-modal mod-lg">
	<bp-modal-header header>
		<a (click)="close()" right href="javascript:" (keydown.enter)="close()" [tabIndex]="0">
			{{ "close" | translate }}
		</a>
	</bp-modal-header>
	<div content class="end-screen-content">
		<img class="end-screen-img" src="/assets/images/failed.svg" [alt]="'deposit_failed_title' | translate" />
		<div class="end-screen-headline">{{ "deposit_failed_title" | translate }}</div>
		<p class="end-screen-description">{{ "deposit_failed_subtitle" | translate }}</p>
		<div class="end-screen-buttons-container">
			<button type="button" class="btn btn-white" (click)="tryAgain()">{{ "try_again" | translate }}</button>
			<button type="button" class="btn btn-primary mod-button-width btn-bold" (click)="changeDepositMethod()">
				{{ "change_deposit_method" | translate }}
			</button>
		</div>
	</div>
</deposit-end-screen-wrapper>
